import { Box, styled } from '@mui/material';
import { LabelSmall } from 'v3/shared/typography/LabelSmall';

export const ResendContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  gap: '0.5rem',
  cursor: 'pointer',
  textDecoration: 'underline',

  '&:hover': {
    color: theme.palette.warning.main,
    textDecoration: 'underline',
  },
}));

export const CountContainer = styled(Box)(({ theme }) => ({
  opacity: '0.8',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  gap: '1rem',
  textAlign: 'center',
}));

export const CustomLabelSmall = styled(LabelSmall)(({ theme }) => ({
  display: 'flex',
  textDecoration: 'underline',
  color: theme.palette.warning.main,
  cursor: 'pointer',
  justifyContent: 'center',
}));
